var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupportSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Help_Icon",
    width: 38,
    height: 38,
    "data-name": "Help Icon",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2px",
    "data-name": "Ellipse 14"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    fill: "#fff",
    d: "M54.279 388.364a2.929 2.929 0 1 0-2.929-2.929 2.929 2.929 0 0 0 2.929 2.929zm2.846 5.979a3.345 3.345 0 0 0-3.256-4.112h-2.527a.861.861 0 0 0-.862.862.73.73 0 0 0 .215.5 1.823 1.823 0 0 1 .5 1.67l-1.317 5.378a3.345 3.345 0 0 0 3.257 4.112h2.525a.861.861 0 0 0 .862-.862.733.733 0 0 0-.214-.5 1.818 1.818 0 0 1-.5-1.67z",
    "data-name": "Path 199",
    transform: "translate(-34.382 -373.361)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupportSmall);
export default __webpack_public_path__ + "static/media/icon-support-small.22c3a7b11f75b24410cef0358fe0ca65.svg";
export { ForwardRef as ReactComponent };